import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'icon', // eslint-disable-line @angular-eslint/component-selector
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class IconComponent implements OnChanges {
  @Input() name :string = '';
  @Input() size :number = 20;

  @ViewChild('iconRef', { static: true }) iconRef :ElementRef;

  constructor() {}

  ngOnChanges(changes :SimpleChanges) {
    if (changes.name) {
      this.iconRef.nativeElement.setAttribute('href', `#${this.name}`);
      // this.iconRef.nativeElement.setAttribute('xlinkHref', `#${this.name}`);
    }
  }
}
